import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  paper: {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    width: "45vw",
    maxHeight: "90vh",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  buttonSave: {
    marginLeft: "10px",
  },
  gridContainerContact: {
    padding: "1.5em !important",
  },
  iconButton: {
    padding: "5px",
  },
  modalBody: {
    height: "100%",
    width: "100%",
  },
  header: {
    padding: "1.5rem",
  },

  titleName: {
    fontFamily: "Manrope",
    fontSize: "20px",
    fontWeight: 700,
    color: "#344054",
    lineHeight: "28px",
  },

  subTitle: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#6F727A",
  },

  locationModalTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  info: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#465869",
  },

  locationButtonsContainer: {
    background: "#F7F7F9",
    width: "100%",
    height: 80,
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
}));

export default styles;
